import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import c from 'classnames';
import ActionBarButton from '../ActionBarButton';
import s from './ActionBarEditButton.scss';
/**
 * Provides some some alternative hover styling compared to `ActionBarButton`.
 */ const ActionBarEditButton = (_param)=>{
    var { className  } = _param, rest = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(ActionBarButton, _extends({
        className: c(s['root'], className)
    }, rest));
};
ActionBarEditButton.displayName = 'ActionBarEditButton';
export default ActionBarEditButton;
